import { z } from "zod";

export const credentialsSignInSchema = z.object({
    username: z.string().min(3),
    password: z.string().min(3),
    company: z.string().min(3),
});

export type CredentialsSignInDto = z.infer<typeof credentialsSignInSchema>;
